module.exports = __webpack_public_path__ + "img/card_1@3x.a680dd76.png";